///<amd-module name="typeahead/core/logging/Leg" />

import {Element} from "typeahead/core/logging/Element";
import {ProblemOrigin} from "typeahead/core/logging/ProblemOrigin";
import {Severity} from "typeahead/core/logging/Severity";
import TypeaheadErrorLogger from "typeahead/core/logging/TypeaheadErrorLogger";

export class Leg {

    public static isOrigin(domElementId: string): boolean {
        domElementId = domElementId.toLowerCase();
        return domElementId.indexOf("origin") > -1 ||
            domElementId.indexOf("from") > -1 ||
            domElementId.indexOf("departure") > -1 ||
            domElementId.indexOf("drop") > -1;
    }

    public static isDestination(domElementId: string): boolean {
        domElementId = domElementId.toLowerCase();
        return domElementId.indexOf("dest") > -1 ||
            domElementId.indexOf("to") > -1 ||
            domElementId.indexOf("arrival") > -1 ||
            domElementId.indexOf("near") > -1 ||
            domElementId.indexOf("pick") > -1 ||
            domElementId.indexOf("uta-search-query") > -1; // open search is considered as destination for now
    }

    private origin: Element;
    private destination: Element;

    public getElement(domElementId: string): Element {
        let isOrigin: boolean = Leg.isOrigin(domElementId);
        let isDestination: boolean = Leg.isDestination(domElementId);

        if (domElementId) {
            if (isOrigin) {
                if (!this.origin) {
                    this.origin = new Element(domElementId);
                }
                return this.origin;
            }

            if (isDestination) {
                if (!this.destination) {
                    this.destination = new Element(domElementId);
                }
                return this.destination;
            }
        }

        if (!isOrigin && !isDestination) {
            TypeaheadErrorLogger.log(new Error("Could not determine origin or destination type for domElementId - "
                + domElementId), Severity.MustFix,  ProblemOrigin.ClientOfUniversalTypeahead);
        }

        if (domElementId) {
            // Honor the element id as provided
            return new Element(domElementId);
        } else {
            // Set a dummy element
            return new Element();
        }
    }

    public getOriginElement(): Element {
        return this.origin ? this.origin : this.getElement("origin");
    }

    public getDestinationElement(): Element {
        return this.destination ? this.destination : this.getElement("destination");
    }
}
